// src/components/StationBlockRow.jsx
import React from 'react';
import StationBlockItem from './StationBlockItem';

const StationBlockRow = ({ trains, keyPrefix, trainBodyClass, eventsEmit }) => {
  // trainBodyClass が "up" のときは local→honors、
  // "down" のときは honors→local の順に並べ替える
  const items = trainBodyClass === 'up'
    ? [
        { list: trains.honors, suffix: 'honors' },
        { list: trains.local,  suffix: 'local'  },
      ]
    : [
        // "down" のときは列車の並び順を逆に
        { list: [...trains.local].reverse(),  suffix: 'local'  },
        { list: [...trains.honors].reverse(), suffix: 'honors' },
      ];

  return (
    <div className="station-block-row">
      {items.map(({ list, suffix }) => (
        <StationBlockItem
          key={`${keyPrefix}_trains_${suffix}`}
          trains={list}
          keyPrefix={`${keyPrefix}_trains_${suffix}`}
          trainBodyClass={trainBodyClass}
          eventsEmit={eventsEmit}
        />
      ))}
    </div>
  );
};

export default StationBlockRow;
